import http from './http'
import {awaitPollStatus} from "./utils";

class EventListener{
    onReceivedQR = (qr) => {console.log("Received unhandeled event `onReceivedQR` with data: " + qr)}
    onReceivedBankIdAutoStartToken = (token) => {console.log("Received unhandeled event `onReceivedBankIdAutoStartToken` with data: " + token)}
    onReceivedCurrentDevice = (currentDevice) => {console.log("Received if BankId is on current device")}
    onReceivedSigningFingerprintStatus = () => {console.log("Received signing fingerprint status")}
}

export const eventListener = new EventListener()

/**
 * Initiates bank account retrieval using Billecta's new iframe-based method.
 * Returns SessionToken and SessionId to be used with Billecta JavaScript client.
 *
 * Usage:
 * getBankAccounts().then(session => {
 *     const client = new Billecta(session.SessionToken, session.SessionId);
 *     client.start({ ... });
 * });
 *
 * @returns {Promise} Promise resolving to {SessionToken, SessionId}
 */
function getBankAccounts() {
    const url = "/wp-json/billecta/v1/bank/accounts/initiate";

    return new Promise((resolve, reject) => {
        http.post(url).then(response => {
            // Return SessionToken and SessionId for iframe-based flow
            resolve(response);
        }).catch(error => reject(error));
    });
}

function getSigningFingerprint(ssn, currentDevice) {
    const url = "/wp-json/billecta/v1/bankid/sign/initiate/" + ssn + '?currentDevice=' + currentDevice

    eventListener.onReceivedCurrentDevice(currentDevice);

    return new Promise((resolve, reject) => {
        http.post(url).then(x => {
            awaitPollStatus(getSigningFingerprintStatus, x['ReferenceToken']).then(response => {
                resolve(response)
            }).catch(x => reject(x))
        }).catch(x => reject(x))
    })
}

function getSigningFingerprintStatus(publicId) {
    const url = "/wp-json/billecta/v1/bankid/sign/" + publicId

    return new Promise((resolve, reject) => {
        http.get(url).then(x => {
            eventListener.onReceivedSigningFingerprintStatus();

            if (x['QR']) {
                eventListener.onReceivedQR(x['QR'])
            }

            if (x['AutoStartToken']) {
                eventListener.onReceivedBankIdAutoStartToken(x['AutoStartToken'])
            }

            if (x && ['Started', 'Waiting', 'UserSign', 'OutstandingTransaction'].indexOf(x['Status']) !== -1) {
                resolve('repeat')
            } else if (x && x['Status'] === 'Complete') {
                resolve(x)
            } else {
                reject(x)
            }
        }).catch(x => reject(x))
    })
}

export default {
    getBankAccounts,
    getSigningFingerprint
}
